export const translations = {
    en: {
        nav: {
            home: "Home",
            menu: "Menu",
            events: "Events",
            location: "Location",
            contact: "Reserve",
            reserveTable: "Reserve a Table",
            callUs: "Call Us",
        },
        hero: {
            eyebrow: "Luxury · Seaside · Bar · Restaurant",
            title1: "Where the Aegean meets the table",
            title2: "meets the table",
            subtitle:
                "An open-air sanctuary on the shore of Mirina. Breakfast at sunrise, brunch in the breeze, cocktails until the last sunset.",
            ctaReserve: "Reserve a Table",
            ctaMenu: "Explore Menu",
            scroll: "Scroll",
        },
        marquee: "Breakfast · Brunch · Lunch · Cocktails · Sunset Views · Outdoor Seating · ",
        about: {
            eyebrow: "About Amos",
            title: "A barefoot kind of luxury",
            body:
                "Amos is a seaside escape rooted in Greek hospitality — white linen, blue horizons and the quiet rhythm of waves. From the first coffee at sunrise to the last cocktail by the sea, every hour is yours to slow down. Stay for breakfast, return for sunset.",
            tag1: "Sunset Cocktails",
            tag2: "Mediterranean Plates",
            tag3: "Beachfront Lounging",
            tag4: "Greek Breakfast",
        },
        features: {
            title: "Four pillars",
            subtitle: "What makes Amos, Amos",
            f1: { title: "Luxury", body: "Considered details, curated comfort, attentive service from morning to last call." },
            f2: { title: "Seaside", body: "Toes-in-the-sand seating with uninterrupted views of the Aegean." },
            f3: { title: "Bar", body: "Classic and signature cocktails, Greek wines, fresh juices and craft non-alcoholic drinks." },
            f4: { title: "Restaurant", body: "Greek mornings, Mediterranean meals, smashed burgers and pinsa under the sun." },
        },
        menuPreview: {
            eyebrow: "On the menu",
            title: "Crafted by the sea",
            body: "From Greek salads and pita toast to truffle smashed burgers and signature cocktails — a menu made for long, lazy hours by the sea.",
            cta: "See the full menu",
        },
        editorial: {
            eyebrow: "From our kitchen",
            title: "Slow mornings, sweet afternoons",
            body: "Wake up to homemade waffles drizzled with Belgian chocolate, freddo espresso brewed strong, or a Greek pita toast that tastes like the island itself. Every plate is built around what's fresh, local and made to share.",
            cta: "See the menu",
        },
        fullBleed: {
            eyebrow: "By the bar",
            title: "Signature drinks, signature sunsets",
            body: "Our bartenders craft over twenty signature cocktails — from the tropical Pame Dubai with gold flakes to the Aegean-blue Crystal G. Best served barefoot, on the sand, as the sky turns gold.",
        },
        finalCta: {
            eyebrow: "Hold your spot",
            title: "Reserve a moment by the sea",
            body: "Whether it's brunch under the umbrellas or sunset cocktails on a sunbed, your seat at Amos is just a click away.",
        },
        location: {
            eyebrow: "Find us",
            title: "On the shore of Mirina",
            address: "Argonafton 8, Mirina 814 00",
            island: "Lemnos, Greece",
            phone: "+30 697 414 1414",
            hours: "Open daily · 09:00 — Late",
            cta: "Open in Google Maps",
            directions: "Get Directions",
        },
        footer: {
            tagline: "Luxury · Seaside · Bar · Restaurant",
            rights: "All rights reserved.",
            nav: "Navigate",
            visit: "Visit",
            contact: "Contact",
        },
        menu: {
            title: "Menu",
            subtitle: "Breakfast · Brunch · Lunch · Drinks",
            tabs: {
                food: "Food",
                alcohol: "Cocktails & Bar",
                drinks: "Coffee & Drinks",
            },
            categories: {
                breakfast: "Breakfast",
                meals: "Meals",
                gluten_free: "Gluten Free — Ask the Staff",
                cocktails: "Cocktails",
                beers: "Beers",
                wines_white: "White Wines",
                wines_rose: "Rosé Wines",
                wines_red: "Red Wines",
                champagne: "Champagne & Sparkling",
                ouzo: "Ouzo & Tsipouro",
                coffees: "Coffee",
                drinks: "Drinks",
                soft: "Soft Drinks",
                juices: "Juices",
                energy: "Energy Drinks",
            },
            unavailable: "Currently unavailable",
        },
        events: {
            title: "Upcoming Events",
            subtitle: "Sunset DJ sets, themed nights and seasonal moments by the sea.",
            empty: "No upcoming events yet",
            emptyBody: "Stay tuned — we're cooking up something special. Check back soon, or follow us on Instagram for first announcements.",
            followCta: "Follow on Instagram",
        },
        reserve: {
            title: "Reserve at Amos",
            subtitle: "Tell us when you'd like to join us — we'll confirm via email or phone.",
            typeTable: "Table",
            typeSunbed: "Sunbed",
            name: "Full name",
            email: "Email",
            phone: "Phone",
            date: "Date",
            time: "Time",
            guests: "Number of guests",
            sunbeds: "Number of sunbeds",
            umbrella: "Add umbrella (morning bookings)",
            umbrellaHint: "Available for bookings before 12:00",
            message: "Special requests",
            sunbedMessagePlaceholder: "Preferred row, umbrella, time of arrival…",
            submit: "Send Reservation",
            sending: "Sending…",
            success: "Thank you! Your reservation request has been received.",
            error: "Something went wrong. Please call us at +30 697 414 1414.",
            or: "or call us directly",
        },
        contact: {
            title: "Reserve your table",
            subtitle: "Tell us when you'd like to join us — we'll confirm via email or phone.",
            name: "Full name",
            email: "Email",
            phone: "Phone",
            date: "Date",
            time: "Time",
            guests: "Guests",
            message: "Special requests",
            submit: "Send Reservation",
            success: "Thank you! Your reservation request has been received.",
            error: "Something went wrong. Please call us at +30 697 414 1414.",
            sending: "Sending...",
            or: "or call us directly",
        },
        maps: {
            title: "Our Location",
            subtitle: "Right on the seafront of Mirina, Lemnos.",
            info: "Information",
            byCar: "By car",
            byCarBody: "Free street parking nearby. 5 minutes from Mirina port.",
            byFoot: "On foot",
            byFootBody: "10 minutes walk from the main town square along the coast.",
        },
    },
    gr: {
        nav: {
            home: "Αρχική",
            menu: "Μενού",
            events: "Εκδηλώσεις",
            location: "Τοποθεσία",
            contact: "Κράτηση",
            reserveTable: "Κράτηση Τραπεζιού",
            callUs: "Καλέστε",
        },
        hero: {
            eyebrow: "Πολυτέλεια · Παραθαλάσσιο · Bar · Εστιατόριο",
            title1: "Εκεί που το Αιγαίο συναντά το τραπέζι",
            title2: "συναντά το τραπέζι",
            subtitle:
                "Ένα υπαίθριο καταφύγιο στην ακτή της Μύρινας. Πρωινό με την ανατολή, brunch με τη θαλασσινή αύρα, κοκτέιλ μέχρι το τελευταίο ηλιοβασίλεμα.",
            ctaReserve: "Κράτηση Τραπεζιού",
            ctaMenu: "Δείτε το Μενού",
            scroll: "Κάντε scroll",
        },
        marquee: "Πρωινό · Brunch · Μεσημεριανό · Κοκτέιλ · Ηλιοβασίλεμα · Εξωτερικός Χώρος · ",
        about: {
            eyebrow: "Για το Amos",
            title: "Πολυτέλεια ξυπόλητη στην άμμο",
            body:
                "Το Amos είναι μια παραθαλάσσια απόδραση γεμάτη ελληνική φιλοξενία — λευκό λινό, μπλε ορίζοντες και ο ήσυχος ρυθμός των κυμάτων. Από τον πρώτο καφέ της ημέρας μέχρι το τελευταίο κοκτέιλ δίπλα στη θάλασσα, κάθε ώρα είναι δική σας. Μείνετε για πρωινό, επιστρέψτε για το ηλιοβασίλεμα.",
            tag1: "Κοκτέιλ στο Ηλιοβασίλεμα",
            tag2: "Μεσογειακή Κουζίνα",
            tag3: "Beachfront Lounging",
            tag4: "Ελληνικό Πρωινό",
        },
        features: {
            title: "Τέσσερις πυλώνες",
            subtitle: "Τι κάνει το Amos, Amos",
            f1: { title: "Πολυτέλεια", body: "Προσεγμένες λεπτομέρειες, άνεση και άψογο σέρβις από το πρωί μέχρι αργά." },
            f2: { title: "Παραθαλάσσιο", body: "Καθίσματα με τα πόδια στην άμμο και ανεμπόδιστη θέα στο Αιγαίο." },
            f3: { title: "Bar", body: "Κλασικά και signature κοκτέιλ, ελληνικά κρασιά, φρέσκοι χυμοί και craft ποτά." },
            f4: { title: "Εστιατόριο", body: "Ελληνικά πρωινά, μεσογειακά γεύματα, smashed burgers και pinsa στον ήλιο." },
        },
        menuPreview: {
            eyebrow: "Στο μενού",
            title: "Φτιαγμένο δίπλα στη θάλασσα",
            body: "Από ελληνική σαλάτα και πίτα toast μέχρι truffle smashed burger και signature κοκτέιλ — ένα μενού για ατέλειωτες ώρες δίπλα στη θάλασσα.",
            cta: "Δείτε όλο το μενού",
        },
        editorial: {
            eyebrow: "Από την κουζίνα μας",
            title: "Αργά πρωινά, γλυκά απογεύματα",
            body: "Ξυπνήστε με σπιτικές βάφλες με βελγική σοκολάτα, freddo espresso, ή ένα ελληνικό πίτα toast που μυρίζει νησί. Κάθε πιάτο φτιάχνεται με ό,τι πιο φρέσκο, τοπικό και αγαπημένο.",
            cta: "Δείτε το μενού",
        },
        fullBleed: {
            eyebrow: "Στο bar",
            title: "Signature ποτά, signature ηλιοβασιλέματα",
            body: "Οι bartenders μας ετοιμάζουν πάνω από είκοσι signature κοκτέιλ — από το tropical Pame Dubai με φύλλα χρυσού μέχρι το γαλάζιο Crystal G. Σερβίρονται καλύτερα ξυπόλητοι, στην άμμο, καθώς ο ουρανός χρυσώνει.",
        },
        finalCta: {
            eyebrow: "Κρατήστε τη θέση σας",
            title: "Κάντε κράτηση για μια στιγμή δίπλα στη θάλασσα",
            body: "Είτε πρόκειται για brunch κάτω από τις ομπρέλες είτε για κοκτέιλ στο ηλιοβασίλεμα σε ξαπλώστρα, η θέση σας στο Amos είναι μόλις ένα κλικ μακριά.",
        },
        location: {
            eyebrow: "Βρείτε μας",
            title: "Στην ακτή της Μύρινας",
            address: "Αργοναυτών 8, Μύρινα 814 00",
            island: "Λήμνος, Ελλάδα",
            phone: "+30 697 414 1414",
            hours: "Καθημερινά · 09:00 — Αργά",
            cta: "Ανοίξτε στο Google Maps",
            directions: "Οδηγίες",
        },
        footer: {
            tagline: "Πολυτέλεια · Παραθαλάσσιο · Bar · Εστιατόριο",
            rights: "Με την επιφύλαξη παντός δικαιώματος.",
            nav: "Πλοήγηση",
            visit: "Επισκεφθείτε",
            contact: "Επικοινωνία",
        },
        menu: {
            title: "Μενού",
            subtitle: "Πρωινό · Brunch · Μεσημεριανό · Ποτά",
            tabs: {
                food: "Φαγητό",
                alcohol: "Κοκτέιλ & Bar",
                drinks: "Καφές & Ποτά",
            },
            categories: {
                breakfast: "Πρωινό",
                meals: "Γεύματα",
                gluten_free: "Χωρίς Γλουτένη — Ρωτήστε το Προσωπικό",
                cocktails: "Κοκτέιλ",
                beers: "Μπύρες",
                wines_white: "Λευκά Κρασιά",
                wines_rose: "Ροζέ Κρασιά",
                wines_red: "Κόκκινα Κρασιά",
                champagne: "Σαμπάνιες & Αφρώδη",
                ouzo: "Ούζο & Τσίπουρο",
                coffees: "Καφέδες",
                drinks: "Ροφήματα",
                soft: "Αναψυκτικά",
                juices: "Χυμοί",
                energy: "Ενεργειακά Ποτά",
            },
            unavailable: "Προσωρινά μη διαθέσιμο",
        },
        events: {
            title: "Επερχόμενες Εκδηλώσεις",
            subtitle: "DJ sets στο ηλιοβασίλεμα, themed βραδιές και ξεχωριστές στιγμές δίπλα στη θάλασσα.",
            empty: "Δεν υπάρχουν επερχόμενες εκδηλώσεις ακόμα",
            emptyBody: "Μείνετε συντονισμένοι — ετοιμάζουμε κάτι ξεχωριστό. Επισκεφθείτε μας ξανά σύντομα ή ακολουθήστε μας στο Instagram.",
            followCta: "Ακολουθήστε στο Instagram",
        },
        reserve: {
            title: "Κράτηση στο Amos",
            subtitle: "Πείτε μας πότε θέλετε να έρθετε — θα επιβεβαιώσουμε με email ή τηλέφωνο.",
            typeTable: "Τραπέζι",
            typeSunbed: "Ξαπλώστρα",
            name: "Ονοματεπώνυμο",
            email: "Email",
            phone: "Τηλέφωνο",
            date: "Ημερομηνία",
            time: "Ώρα",
            guests: "Αριθμός ατόμων",
            sunbeds: "Αριθμός ξαπλωστρών",
            umbrella: "Προσθήκη ομπρέλας (πρωινές κρατήσεις)",
            umbrellaHint: "Διαθέσιμη για κρατήσεις πριν τις 12:00",
            message: "Ειδικά αιτήματα",
            sunbedMessagePlaceholder: "Προτιμώμενη σειρά, ομπρέλα, ώρα άφιξης…",
            submit: "Αποστολή Κράτησης",
            sending: "Αποστολή…",
            success: "Ευχαριστούμε! Η αίτηση κράτησής σας ελήφθη.",
            error: "Κάτι πήγε στραβά. Καλέστε μας στο +30 697 414 1414.",
            or: "ή καλέστε μας απευθείας",
        },
        contact: {
            title: "Κάντε κράτηση",
            subtitle: "Πείτε μας πότε θέλετε να έρθετε — θα επιβεβαιώσουμε με email ή τηλέφωνο.",
            name: "Ονοματεπώνυμο",
            email: "Email",
            phone: "Τηλέφωνο",
            date: "Ημερομηνία",
            time: "Ώρα",
            guests: "Άτομα",
            message: "Ειδικά αιτήματα",
            submit: "Αποστολή Κράτησης",
            success: "Ευχαριστούμε! Η αίτηση κράτησής σας ελήφθη.",
            error: "Κάτι πήγε στραβά. Καλέστε μας στο +30 697 414 1414.",
            sending: "Αποστολή...",
            or: "ή καλέστε μας απευθείας",
        },
        maps: {
            title: "Η Τοποθεσία μας",
            subtitle: "Στην παραλία της Μύρινας, Λήμνος.",
            info: "Πληροφορίες",
            byCar: "Με αυτοκίνητο",
            byCarBody: "Δωρεάν parking κοντά. 5 λεπτά από το λιμάνι της Μύρινας.",
            byFoot: "Με τα πόδια",
            byFootBody: "10 λεπτά περπάτημα από την κεντρική πλατεία κατά μήκος της ακτής.",
        },
    },
};
